type EventParticipantProps = {
  participantData: { name: string; minutes: string[] }[];
  homeTeam: boolean;
};

export const EventParticipant = ({ participantData, homeTeam }: EventParticipantProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: homeTeam ? 'flex-end' : 'flex-start',
        flex: 1,
        textAlign: homeTeam ? 'right' : 'left',
        width: 'calc(50% - 24px)',
      }}
    >
      {participantData.map((player) => (
        <div
          key={player.name}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: '4px',
            flexWrap: 'wrap',
          }}
        >
          <div
            style={{
              display: 'block',
            }}
          >
            <span
              style={{
                marginRight: '4px',
                fontSize: '12px',
                lineHeight: '20px',
                fontWeight: '400',
                fontStyle: 'normal',
                fontFamily: 'var(--fonts-primaryFontFamily)',
                textAlign: 'right',
                color: 'var(--colors-mainEventParticipantNameColor)',
                flexShrink: 0,
                whiteSpace: 'nowrap',
              }}
            >
              {player.name}
            </span>
            <span
              style={{
                color: 'var(--colors-secondaryMainEventParticipantNameColor)',
                fontSize: '12px',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'right',
                maxWidth: '64px',
                lineHeight: '20px',
                fontFamily: 'var(--fonts-primaryFontFamily)',
                display: 'inline',
                whiteSpace: 'normal',
              }}
            >
              {player.minutes.join(', ')}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
